/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addProfileCertification } from '../fn/profile-certification/add-profile-certification';
import { AddProfileCertification$Params } from '../fn/profile-certification/add-profile-certification';
import { BooleanResponse } from '../models/boolean-response';
import { deleteProfileCertification } from '../fn/profile-certification/delete-profile-certification';
import { DeleteProfileCertification$Params } from '../fn/profile-certification/delete-profile-certification';
import { listProfileCertification } from '../fn/profile-certification/list-profile-certification';
import { ListProfileCertification$Params } from '../fn/profile-certification/list-profile-certification';
import { ProfileCertification } from '../models/profile-certification';
import { updateProfileCertification } from '../fn/profile-certification/update-profile-certification';
import { UpdateProfileCertification$Params } from '../fn/profile-certification/update-profile-certification';

@Injectable({ providedIn: 'root' })
export class ProfileCertificationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listProfileCertification()` */
  static readonly ListProfileCertificationPath = '/rest/profile/{id}/certification';

  /**
   * List all existing profile certifications for profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listProfileCertification()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileCertification$Response(params: ListProfileCertification$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileCertification>>> {
    return listProfileCertification(this.http, this.rootUrl, params, context);
  }

  /**
   * List all existing profile certifications for profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listProfileCertification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listProfileCertification(params: ListProfileCertification$Params, context?: HttpContext): Observable<Array<ProfileCertification>> {
    return this.listProfileCertification$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileCertification>>): Array<ProfileCertification> => r.body)
    );
  }

  /** Path part for operation `addProfileCertification()` */
  static readonly AddProfileCertificationPath = '/rest/profile/{id}/certification';

  /**
   * Add new profile certification. Profile certification type/year/profile cannot be updated.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addProfileCertification()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProfileCertification$Response(params: AddProfileCertification$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileCertification>> {
    return addProfileCertification(this.http, this.rootUrl, params, context);
  }

  /**
   * Add new profile certification. Profile certification type/year/profile cannot be updated.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addProfileCertification$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addProfileCertification(params: AddProfileCertification$Params, context?: HttpContext): Observable<ProfileCertification> {
    return this.addProfileCertification$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileCertification>): ProfileCertification => r.body)
    );
  }

  /** Path part for operation `updateProfileCertification()` */
  static readonly UpdateProfileCertificationPath = '/rest/profile/{id}/certification/{type}/{year}';

  /**
   * Update existing profile certification. Profile, type or year cannot be changed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProfileCertification()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProfileCertification$Response(params: UpdateProfileCertification$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileCertification>> {
    return updateProfileCertification(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing profile certification. Profile, type or year cannot be changed.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProfileCertification$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProfileCertification(params: UpdateProfileCertification$Params, context?: HttpContext): Observable<ProfileCertification> {
    return this.updateProfileCertification$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileCertification>): ProfileCertification => r.body)
    );
  }

  /** Path part for operation `deleteProfileCertification()` */
  static readonly DeleteProfileCertificationPath = '/rest/profile/{id}/certification/{type}/{year}';

  /**
   * Delete profile certification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProfileCertification()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProfileCertification$Response(params: DeleteProfileCertification$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return deleteProfileCertification(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete profile certification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProfileCertification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProfileCertification(params: DeleteProfileCertification$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.deleteProfileCertification$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

}
